<template>
  <div class="operator-view">
    <QrCodeScanner class="operator-camera" />
  </div>
</template>

<script>
  import QrCodeScanner from '@/components/QrCodeScanner.vue';

  export default {
    name: 'operator-view',
    components: {
      QrCodeScanner,
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .operator-view {
    position: relative;
  }

  .heading {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-block-start: calc(0.67em + 1rem);
    z-index: 100000;
  }
</style>
